import React from "react";
import { useTranslation } from "react-i18next";

function Loading() {
  const [t] = useTranslation();

  return (
    <div id="page">
      <div id="container">
        <div id="ring"></div>
        <div id="ring"></div>
        <div id="ring"></div>
        <div id="ring"></div>
        <div id="h3">{t("loading")}</div>
      </div>
    </div>
  );
}

export default Loading;
